import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Calendar, Download, ExternalLink } from 'lucide-react';
import { GrasrotandelenBanner } from '../components/GrasrotandelenBanner';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

const getyears = () => [
  {
    year: '2026',
    date: t('pg.Aarsmoeteprotokoll.1581a6'),
    status: 'available',
    description: t('pg.Aarsmoeteprotokoll.79d231'),
  },
  {
    year: '2025',
    date: t('pg.Aarsmoeteprotokoll.6a0b6d'),
    status: 'available',
    description: t('pg.Aarsmoeteprotokoll.70c758'),
  },
];

export const Aarsmoeteprotokoll = () => {
  useTranslation();
  return (
    <div data-testid="aarsmoeteprotokoll-page" className="min-h-screen bg-slate-50 dark:bg-slate-900">
      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8 bg-white dark:bg-slate-800">
        <div className="max-w-4xl mx-auto">
          <Link 
            to="/styret" 
            className="inline-flex items-center gap-2 text-slate-500 hover:text-green-600 transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('pg.Aarsmoeteprotokoll.6e689e')}
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center">
              <FileText className="w-7 h-7 text-green-600" />
            </div>
            <div>
              <p className="text-green-600 font-medium uppercase tracking-widest mb-1">{t('pg.Aarsmoeteprotokoll.aabad0')}</p>
              <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter text-slate-900 dark:text-white">
                {t('pg.Aarsmoeteprotokoll.d7d853')}
              </h1>
            </div>
          </div>
          
          <p className="text-slate-600 text-lg">
            {t('pg.Aarsmoeteprotokoll.c9aef2')}
          </p>
        </div>
      </section>

      {/* Years Grid */}
      <section className="px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-4xl mx-auto">
          <div className="grid sm:grid-cols-2 gap-6">
            {getyears().map((item) => (
              <Link
                key={item.year}
                to={`/aarsmoeteprotokoll/${item.year}`}
                data-testid={`protocol-year-${item.year}`}
                className={`
                  bg-white rounded-2xl border transition-all duration-300 overflow-hidden group shadow-sm hover:shadow-md
                  ${item.status === 'available' 
                    ? 'border-green-300 hover:border-green-500' 
                    : 'border-slate-200 hover:border-slate-300'
                  }
                `}
              >
                <div className="p-8">
                  <div className="flex items-center justify-between mb-4">
                    <div className={`
                      w-12 h-12 rounded-xl flex items-center justify-center
                      ${item.status === 'available' ? 'bg-green-500' : 'bg-slate-100'}
                    `}>
                      <Calendar className={`w-6 h-6 ${item.status === 'available' ? 'text-white' : 'text-slate-400'}`} />
                    </div>
                    {item.status === 'available' && (
                      <span className="bg-green-100 text-green-600 text-xs font-bold px-3 py-1 rounded-full uppercase">
                        {t('pg.Aarsmoeteprotokoll.fcb1e8')}
                      </span>
                    )}
                    {item.status === 'upcoming' && (
                      <span className="bg-slate-100 text-slate-500 text-xs font-bold px-3 py-1 rounded-full uppercase">
                        {t('pg.Aarsmoeteprotokoll.3eb040')}
                      </span>
                    )}
                  </div>
                  
                  <h2 className={`
                    text-4xl font-bold mb-2
                    ${item.status === 'available' ? 'text-green-600' : 'text-slate-400'}
                  `}>
                    {item.year}
                  </h2>
                  
                  <p className="text-slate-500 text-sm mb-4">{item.date}</p>
                  
                  <p className="text-slate-600 dark:text-slate-300">{item.description}</p>
                  
                  <div className={`
                    mt-6 inline-flex items-center gap-2 font-medium text-sm
                    ${item.status === 'available' 
                      ? 'text-green-600 group-hover:underline' 
                      : 'text-slate-400'
                    }
                  `}>
                    {item.status === 'available' ? t('pg.Aarsmoeteprotokoll.b746de') : t('pg.Aarsmoeteprotokoll.5a91f5')}
                    {item.status === 'available' && <ExternalLink className="w-4 h-4" />}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Grasrotandelen Banner */}
      <GrasrotandelenBanner />
    </div>
  );
};

export default Aarsmoeteprotokoll;
